import * as Colors from '../../../consts/variables';
import * as React from 'react';
import styled from '@emotion/styled';

import { RootStateOrAny, useSelector } from 'react-redux';

import { EmailShare } from '../../Share/EmailShare/EmailShare';
import { Share } from '../../Icons/Share';
import { SocialShare } from '../../Share/SocialShare/SocialShare';
import { __ } from '../../../helpers/TranslationService';

const style: Record<string, React.CSSProperties> = {
    shareIconBlack: {
        fill: Colors.softBlack,
        display: 'block',
        marginRight: 0,
    },
};

const TooltipShareLinks = styled.span`
    visibility: hidden;
    width: 109px;
    background-color: ${({ theme }) => theme.background.brandColor2};
    color: ${({ theme }) => theme.colors.white[100]};
    text-align: center;
    position: absolute;
    z-index: 1;
    top: 3.5rem;
    right: 35%;
    margin-left: -60px;
    opacity: 0;
    display: flex;

    > a {
        float: left;
        width: 21px !important;
        margin-right: 3px !important;
        margin-left: 9px !important;
        background-color: transparent !important;
        border-color: transparent !important;

        &:last-child {
            margin-right: 10px !important;
        }
    }

    &:after {
        content: ' ';
        position: absolute;
        bottom: 100%; /* This will position the arrow at the top of the tooltip */
        right: 18%;
        margin-left: -10px;
        border-width: 10px;
        border-style: solid;
        border-color: transparent transparent ${({ theme }) => theme.background.brandColor2}
            transparent;
    }
`;

export const ShareButton = () => {
    const iconColor = style.shareIconBlack;
    const { canonicalUrl } = useSelector((state: RootStateOrAny) => state.cruisePage);

    return (
        <div data-testid="share-btn" className="btn-share tooltip-icon-share">
            <div className="vcenter action-icon">
                <Share style={{ ...iconColor }} />
            </div>
            <span className="text-center vcenter">{__('share', 'dreamlines')}</span>
            <TooltipShareLinks className="tooltip-icon-share-text">
                <SocialShare shareLink={canonicalUrl} />
                <EmailShare shareLink={canonicalUrl} />
            </TooltipShareLinks>
        </div>
    );
};
